import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import RoleCard from './RoleCard'
import AuthenticationServices from '../../../services/axiosServices/apiServices/AuthenticationServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import RoleModal from './RoleModal';
import { CommonValidationMessages } from '../../../utils/Messages';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import UserServices from '../../../services/axiosServices/apiServices/UserServices';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from 'ag-grid-react';

export default class RoleManagement extends Component {
    constructor(props) {
        super(props);
        this.authServices = new AuthenticationServices();
        this.userServices = new UserServices();
        this.swalServices = new SwalServices();
        this.state = {
            addRoleModalOpen: false,
            roles: [],
            roleCategoryList: [],
            roleObject: {
                roleId: 0,
                roleName: "",
                roleCategoryId: 0,
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                roleName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "role"
                        ),
                    },
                ],
                roleCategoryId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "detail"
                        ),
                    },
                ],
            },
            rowData: [],
            colDefs: [
                {
                    headerName: "Sr No",
                    valueGetter: "node.rowIndex + 1",
                    flex: 0.2,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "Role Name",
                    field: "roleName",
                    flex: 1.5,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "Role Category",
                    field: "roleCategoryName",
                    flex: 1.0,
                    filter: true,
                    floatingFilter: true,
                }
            ],
            paginationPageSize: 10,
            rowHeight: 40,
        };
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.roleObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    onRowDoubleClicked = (params) => {
        if (params?.data) {
            this.openAddEditRole(params.data, "Edit");
        }
    };

    openAddEditRole = (role, itsFor) => {
        if (itsFor === "Add") {
            this.setState({
                roleObject: {
                    roleId: 0,
                    roleName: "",
                    roleCategoryId: 0,
                },
                addRoleModalOpen: true
            });
        } else {
            this.setState({
                roleObject: {
                    roleId: role.roleId,
                    roleName: role.roleName,
                    roleCategoryId: role.roleCategoryId,
                },
                addRoleModalOpen: true
            });
        }
    };


    handleChange = (event, name) => {
        let details = this.state.roleObject;
        if (name === 'roleCategoryId') {
            details[name] = event.value;
        } else {
            let value = event.target.value;
            details[name] = value;
        }
        this.setState({ roleObject: details });
    }

    componentDidMount() {
        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.getAllRoleCategory();
                this.getRoles();
            });
        }

    }

    getRoles = () => {
        this.authServices.getRoles().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                const list = response.responseItem.responseContent;
                // if (list?.length > 0) {
                //     this.setState({
                //         roles: list,
                //         rowData: list,
                //     });
                // }
                this.setState({
                    roles: list,
                    rowData: list,
                }, () => {
                    if (this.gridApi) {
                        if (list.length === 0) {
                            this.gridApi.showNoRowsOverlay();
                        } else {
                            this.gridApi.hideOverlay();
                        }
                    }
                });
            }
        });
    };

    getAllRoleCategory = () => {
        this.userServices.getAllRoleCategory().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                const list = response.responseItem.responseContent;
                if (list?.length > 0) {
                    const roleCategory = list
                        .map(x => ({
                            label: x.roleCategoryName,
                            value: x.roleCategoryId
                        }));

                    this.setState({
                        roleCategoryList: roleCategory,
                    });
                }
            }
        });
    };

    submit = () => {
        if (!this.isValidAllFields()) return;
        let req = {
            roleId: this.state.roleObject.roleId,
            roleName: this.state.roleObject.roleName,
            roleCategoryId: this.state.roleObject.roleCategoryId,
        };
        this.userServices.addEditRole(req).then((res) => {
            if (res?.statusCode === 200) {
                if (res?.responseItem?.responseContent[0]?.messageType === "Exists") {
                    this.swalServices.Error(res?.responseItem?.responseContent[0]?.message);
                } else {
                    this.swalServices.Success(res?.responseItem?.responseContent[0]?.message);
                    this.getRoles();
                    this.setState({ addRoleModalOpen: false });
                }
            }
        });
    };

    handleDelete = () => {
        const selected = this.state.roleObject.roleId;
        if (selected <= 0) {
            this.swalServices.Error("Please select a role to delete.");
            return;
        }
        const id = selected;
        this.userServices.roleDelete(id).then((res) => {
            if (res?.statusCode === 200) {
                if (res?.responseItem?.responseContent[0]?.isDeleted) {
                    this.swalServices.Success(res?.responseItem?.responseContent[0]?.message);
                    this.getRoles();
                    this.setState({ addRoleModalOpen: false });
                } else {
                    this.swalServices.Error(res?.responseItem?.responseContent[0]?.message);
                    //this.getRoles();
                    this.setState({ addRoleModalOpen: false }, () => { this.getRoles() });
                }
            }
        });
    };

    render() {
        //const roles = ["Admin", "Manager", "HR", "Support"];

        return (
            <div className='role-management'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openAddEditRole('', "Add"),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                                // delete: this.handleDelete,
                            }}
                        />

                    </div>
                </div>
                {/* <div className='management-inner grid grid-cols-4 gap-5 mt-2.5'>
                    {this.state.roles.map((role, index) => (
                        <RoleCard
                            key={index}
                            role={role}
                            onClick={() => this.openAddEditRole(role, "Edit")}
                        />
                    ))}
                </div> */}
                <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                    <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                        <div className="table-inner">
                            <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Role management</h1>
                        </div>
                        <AgGridReact
                            rowData={this.state.rowData}
                            rowHeight={this.state.rowHeight}
                            columnDefs={this.state.colDefs}
                            pagination={true}
                            paginationPageSize={this.state.paginationPageSize}
                            onRowDoubleClicked={this.onRowDoubleClicked}
                            onGridReady={this.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <RoleModal
                    addRoleModalOpen={this.state.addRoleModalOpen}
                    setAddRoleModalOpen={(val) => this.setState({ addRoleModalOpen: val })}
                    roleObject={this.state.roleObject}
                    roleCategoryList={this.state.roleCategoryList}
                    handleChange={this.handleChange}
                    save={this.submit.bind(this)}
                    validState={this.state.validState}
                    delete={this.handleDelete.bind(this)}
                />
            </div>
        )
    }
}
